/**
 * Converts an array of objects into a record, using a key selector function to determine the keys.
 *
 * @template T - The type of objects in the array.
 * @param {T[]} array - The array of objects to convert.
 * @param {(item: T) => string} keySelector - The function that selects the key for each object.
 * @returns {Record<string, T>} - The resulting record, where the keys are determined by the key selector function and the values are the objects from the array.
 */
export function arrayToRecord<T>(
  array: T[],
  keySelector: (item: T) => string
): Record<string, T> {
  const record: Record<string, T> = {};

  for (const item of array) {
    const key = keySelector(item);
    record[key] = item;
  }

  return record;
}
